module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-info"
  }, [_c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.printDialog,
      "header": "Do you want to print this bill?",
      "modal": true
    },
    on: {
      "update:visible": function($event) {
        _vm.printDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded p-button-success",
    attrs: {
      "label": "Yes",
      "icon": "pi pi-check"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "No"
    },
    on: {
      "click": _vm.closePrintDialog
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Purchase Batch Details",
      "modal": true,
      "visible": _vm.displayBasicBatchDetails,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "show": _vm.checkNepaliDateOrEnglish,
      "update:visible": function($event) {
        _vm.displayBasicBatchDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasicBatchDetails.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-rounded p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasicBatchDetails.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Batch Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.batch),
      callback: function($$v) {
        _vm.batch = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "batch"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Bonus")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "shortName"
    },
    model: {
      value: (_vm.bonus),
      callback: function($$v) {
        _vm.bonus = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "bonus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "manufactureDate"
    }
  }, [_vm._v("Manufacture Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "man",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.manufactureDate),
      callback: function($$v) {
        _vm.manufactureDate = $$v
      },
      expression: "manufactureDate"
    }
  }) : _c('InputMask', {
    ref: "man",
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "manufactureDate"
    },
    model: {
      value: (_vm.manufactureDate),
      callback: function($$v) {
        _vm.manufactureDate = $$v
      },
      expression: "manufactureDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "expiryDate"
    }
  }, [_vm._v("Expiry Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "exp",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.expiryDate),
      callback: function($$v) {
        _vm.expiryDate = $$v
      },
      expression: "expiryDate"
    }
  }) : _c('InputMask', {
    ref: "exp",
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "expiryDate"
    },
    model: {
      value: (_vm.expiryDate),
      callback: function($$v) {
        _vm.expiryDate = $$v
      },
      expression: "expiryDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "shortName"
    }
  }, [_vm._v("Free Qty")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "free",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.freeQty),
      callback: function($$v) {
        _vm.freeQty = $$v
      },
      expression: "freeQty"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "ccPercentage"
    }
  }, [_vm._v("Cc Percentage")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "ccPercentage",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.ccPercentage),
      callback: function($$v) {
        _vm.ccPercentage = $$v
      },
      expression: "ccPercentage"
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Variants Details",
      "modal": true,
      "visible": _vm.displayVarientsDetails,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayVarientsDetails = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-rounded",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.saveVariantDetails.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-rounded p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeVarientsDetails.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('Button', {
    staticClass: "p-button-rounded p-button-info",
    attrs: {
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        return _vm.addNewVariant()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-12"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table",
    attrs: {
      "value": _vm.itemPropertyInventoryValuesDTOList,
      "editMode": "cell"
    }
  }, [_vm._l((_vm.itemPropertyValuesDTOList), function(col) {
    return _c('Column', {
      key: col.entryTypeName,
      attrs: {
        "field": col.entryTypeName,
        "header": col.entryTypeName
      },
      scopedSlots: _vm._u([{
        key: "body",
        fn: function(slotProps) {
          return [_c('Dropdown', {
            attrs: {
              "options": col.childIItemMasterPropertyList,
              "optionLabel": "propertyName",
              "optionValue": "propertyName",
              "placeholder": "Select Property"
            },
            on: {
              "change": function($event) {
                return _vm.addValueforProperty(slotProps.data[slotProps.column.field], col.entryTypeName)
              }
            },
            model: {
              value: (slotProps.data[slotProps.column.field]),
              callback: function($$v) {
                _vm.$set(slotProps.data, slotProps.column.field, $$v)
              },
              expression: "slotProps.data[slotProps.column.field]"
            }
          })]
        }
      }], null, true)
    })
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Value",
      "field": "propertyValue"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (slotProps.data.propertyValue),
            expression: "slotProps.data.propertyValue"
          }],
          staticClass: "form-control",
          attrs: {
            "type": "text",
            "disabled": ""
          },
          domProps: {
            "value": (slotProps.data.propertyValue)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(slotProps.data, "propertyValue", $event.target.value)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Quantity",
      "field": "quantity"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          attrs: {
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }])
  })], 2)], 1)])], 1), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-3"
  }, [_c('label', {
    attrs: {
      "for": "transactionDate"
    }
  }, [_vm._v("Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    ref: "tran",
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  }) : _c('InputMask', {
    ref: "tran",
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "transactionDate"
    },
    model: {
      value: (_vm.transactionDate),
      callback: function($$v) {
        _vm.transactionDate = $$v
      },
      expression: "transactionDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 p-xl-3"
  }, [_c('label', {
    attrs: {
      "for": "transactionDate"
    }
  }, [_vm._v("Purchase Date")]), _vm._v(" "), (!_vm.englishDateEnabled) ? _c('date-picker', {
    attrs: {
      "valueType": "format"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  }) : _c('InputMask', {
    staticClass: "nepali-calendar form-control",
    attrs: {
      "mask": "9999-99-99",
      "type": "text",
      "id": "purchaseSalesDate"
    },
    model: {
      value: (_vm.purchaseSalesDate),
      callback: function($$v) {
        _vm.purchaseSalesDate = $$v
      },
      expression: "purchaseSalesDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "billNo"
    }
  }, [_vm._v("Bill No")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "billNo",
      "disabled": ""
    },
    model: {
      value: (_vm.billNo),
      callback: function($$v) {
        _vm.billNo = $$v
      },
      expression: "billNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "refno"
    }
  }, [_vm._v("Ref. No.")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "refno"
    },
    model: {
      value: (_vm.refNo),
      callback: function($$v) {
        _vm.refNo = $$v
      },
      expression: "refNo"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "purType"
    }
  }, [_vm._v("Purchase Type")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.taxType),
      expression: "taxType"
    }],
    staticClass: "selectBox",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.taxType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select One")]), _vm._v(" "), _vm._l((_vm.taxTypeList), function(tax, ind) {
    return _c('option', {
      key: ind
    }, [_vm._v(_vm._s(tax.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-3"
  }, [_c('label', {
    attrs: {
      "for": "loadFrom"
    }
  }, [_vm._v("Load From")]), _vm._v(" "), _c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadType),
      expression: "loadType"
    }],
    attrs: {
      "type": "radio",
      "name": "order",
      "value": "order"
    },
    domProps: {
      "checked": _vm._q(_vm.loadType, "order")
    },
    on: {
      "change": [function($event) {
        _vm.loadType = "order"
      }, function($event) {
        return _vm.loadFrom(_vm.loadType)
      }]
    }
  }), _vm._v("Order")])]), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadType),
      expression: "loadType"
    }],
    attrs: {
      "type": "radio",
      "name": "challan",
      "value": "challan"
    },
    domProps: {
      "checked": _vm._q(_vm.loadType, "challan")
    },
    on: {
      "change": [function($event) {
        _vm.loadType = "challan"
      }, function($event) {
        return _vm.loadFrom(_vm.loadType)
      }]
    }
  }), _vm._v("Challan")])])])]), _vm._v(" "), (_vm.loadFromOrder && !this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-4"
  }, [(_vm.loadFromOrder && !this.editing) ? _c('label', {
    attrs: {
      "for": "OrderList"
    }
  }, [_vm._v(" Order List")]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.orderIdList,
      "optionLabel": "orderNo",
      "filter": true,
      "placeholder": "Select Item"
    },
    on: {
      "change": function($event) {
        return _vm.loadPurchaseDataWithOrderId(_vm.orderId.orderNo)
      }
    },
    model: {
      value: (_vm.orderId),
      callback: function($$v) {
        _vm.orderId = $$v
      },
      expression: "orderId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loadFromChallan && !this.editing) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-4"
  }, [(_vm.loadFromChallan && !this.editing) ? _c('label', {
    attrs: {
      "for": "ChallanList"
    }
  }, [_vm._v(" Challan List")]) : _vm._e(), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.challanIdList,
      "optionLabel": "challanNo",
      "filter": true,
      "placeholder": "Select Item"
    },
    on: {
      "change": function($event) {
        return _vm.loadPurchaseDataWithChallanId(_vm.challanId.challanNo)
      }
    },
    model: {
      value: (_vm.challanId),
      callback: function($$v) {
        _vm.challanId = $$v
      },
      expression: "challanId"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-10 p-lg-3"
  }, [_c('label', [_vm._v("Vendor")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.supplierAndCustomerList,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select Account",
      "showClear": true
    },
    model: {
      value: (_vm.accountMaster),
      callback: function($$v) {
        _vm.accountMaster = $$v
      },
      expression: "accountMaster"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('supplierDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Supplier'),
      expression: "'Add Supplier'",
      modifiers: {
        "top": true
      }
    }]
  })], 1), _vm._v(" "), (_vm.ifCash) ? _c('div', {
    staticClass: "p-field p-col-10 p-lg-3"
  }, [_c('label', [_vm._v("Supplier")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.customerAccountList,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select supplier",
      "showClear": true
    },
    model: {
      value: (_vm.cashTransactionMaster),
      callback: function($$v) {
        _vm.cashTransactionMaster = $$v
      },
      expression: "cashTransactionMaster"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.ifCash) ? _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('supplierDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Supplier'),
      expression: "'Add Supplier'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_supplier_master": _vm.set_supplier_master
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-10 p-lg-3"
  }, [(!_vm.ifNotCash) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [(_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Tax No:")]), _vm._v(" "), _c('b', {
    staticClass: "p-ml-0",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "id": "panNo"
    }
  }, [_vm._v(_vm._s(_vm.accountMaster.panNo))])]) : _vm._e(), _vm._v(" "), (_vm.accountMaster.id > 0) ? _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    attrs: {
      "for": "panNo"
    }
  }, [_vm._v("Cur. Bal:")]), _vm._v(" "), (_vm.accountMaster.closingBalance > 0) ? _c('b', {
    staticClass: "p-ml-4",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n            " + _vm._s((_vm.accountMaster.closingBalance).toFixed(2) + 'Cr') + "\n          ")]) : _c('b', {
    staticClass: "p-ml-4",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("\n            " + _vm._s((_vm.accountMaster.closingBalance * (-1)).toFixed(2) + 'Dr') + "\n          ")])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-10 p-lg-2"
  }, [_c('label', {
    attrs: {
      "for": "warehouse"
    }
  }, [_vm._v("Store")]), _vm._v(" "), (!_vm.setWarehouseData) ? _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "filter": true,
      "placeholder": "Select store",
      "showClear": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  }) : _c('Dropdown', {
    attrs: {
      "options": _vm.warehouseLists,
      "optionLabel": "name",
      "id": "warehouse",
      "filter": true,
      "placeholder": "Select warehouse",
      "disabled": true
    },
    model: {
      value: (_vm.warehouse),
      callback: function($$v) {
        _vm.warehouse = $$v
      },
      expression: "warehouse"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-2 align-self-end"
  }, [_c('warehouseDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Warehouse'),
      expression: "'Add Warehouse'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_warehouse": _vm.set_data_warehouse
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-10 p-lg-3"
  }, [_vm._m(0), _vm._v(" "), _c('AutoComplete', {
    ref: "itm",
    attrs: {
      "filterMatchMode": "contains",
      "id": "itm",
      "suggestions": _vm.filteredItems,
      "field": "name"
    },
    on: {
      "complete": function($event) {
        return _vm.searchItem($event)
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(slotProps) {
        return [_c('div', {
          staticStyle: {
            "font-size": "12px !important"
          }
        }, [_vm._v(_vm._s(slotProps.item.name) + " - " + _vm._s(slotProps.item.itemCode))])]
      }
    }]),
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-2 p-lg-4 p-xl-1 align-self-end"
  }, [_c('itemDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Item'),
      expression: "'Add Item'",
      modifiers: {
        "top": true
      }
    }],
    on: {
      "set_data_item": _vm.set_data_item
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "qty",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), (!_vm.items.isMultiUnit) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "qty"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('InputText', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: (_vm.items.unitName),
      callback: function($$v) {
        _vm.$set(_vm.items, "unitName", $$v)
      },
      expression: "items.unitName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.items.isMultiUnit) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.items.itemMultiUnitDetailsDTOList,
      "optionLabel": "unitTo",
      "filter": true,
      "placeholder": "Select One",
      "id": "unit"
    },
    model: {
      value: (_vm.alternateUnit),
      callback: function($$v) {
        _vm.alternateUnit = $$v
      },
      expression: "alternateUnit"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.items.isMultiUnit) ? _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "unit"
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "p-button-rounded p-button-secondary",
    attrs: {
      "label": "Detail"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openConversionDialog(_vm.unitConversion)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('UniConversionDetail', {
    ref: "conversionDialog"
  }), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-1"
  }, [_c('label', {
    attrs: {
      "for": "rate"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "rate",
      "mode": "decimal",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.rate),
      callback: function($$v) {
        _vm.rate = $$v
      },
      expression: "rate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "total"
    }
  }, [_vm._v("Total")]), _vm._v(" "), (_vm.$store.state.organisationid != 17) ? _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "minmaxfraction",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  }) : _c('InputNumber', {
    attrs: {
      "id": "minmaxfraction",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    on: {
      "keyup": _vm.findRate
    },
    model: {
      value: (_vm.total),
      callback: function($$v) {
        _vm.total = $$v
      },
      expression: "total"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalAmount))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.setRateFromItem))]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-1 p-lg-4 p-xl-1 align-self-end"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": !_vm.editDTO ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToDTOList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.editDTO) ? _c('div', {
    staticClass: "p-field p-col-1 p-lg-4 p-xl-1 align-self-end"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.itemDTOreset
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-8"
  }, [(_vm.items.id > 0) ? _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-align-center h-100"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4 mb-0"
  }, [_c('label', {
    attrs: {
      "for": "avl"
    }
  }, [_vm._v("Current. Stock:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.items.closingStock))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-12 genTable"
  }, [_c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines"
  }, [_c('div', {
    staticClass: "scrollable"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Item Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Hs Code")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Unit")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Rate")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Action")]), _vm._v(" "), (this.$store.getters.modules.includes('5.33')) ? _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Size-Color")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.inventoryInOutDetailList), function(item, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.itemNameWithCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.itemMaster.hsCode))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.quantity))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.itemMaster.unitName))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.rate))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s((item.rate * item.quantity).toFixed(4)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          return _vm.editItemFromDTO(item, index)
        }
      }
    }), _vm._v(" "), (_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : (!_vm.editDTO) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          return _vm.removeItemFromDTO(item, index)
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), (_vm.checkSizeAndColor) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-success",
      attrs: {
        "icon": "pi pi-eye"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openBasicForSizeAndColor(item)
        }
      }
    })], 1) : _vm._e()])])
  }), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Total:")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalQty))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subTotal.toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(" ")]), _vm._v(" "), (this.$store.getters.modules.includes('5.33')) ? _c('td', [_vm._v(" ")]) : _vm._e()])])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-4"
  }, [_c('label', [_vm._v("Narration")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.narration),
      expression: "narration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.narration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.narration = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2 mt-25"
  }, [_c('Button', {
    staticClass: "p-button-warning",
    attrs: {
      "icon": "pi pi-refresh",
      "label": "Reset"
    },
    on: {
      "click": _vm.reset
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-3 p-xl-2 mt-25"
  }, [_c('form', [_c('Button', {
    staticClass: "p-button p-button-success addNewBtn btn-btm-0 width-auto",
    attrs: {
      "label": "Extra Expenses",
      "icon": "pi pi-plus"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openBasic.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('Dialog', {
    attrs: {
      "header": "Extra Expenses",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'auto'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "icon": "pi pi-save",
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasic.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-9 p-lg-6 p-xl-3"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("Extra Expenses Name")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.extraExpensesList,
      "optionLabel": "expensesName",
      "filter": true,
      "placeholder": "Select Expenses",
      "id": "extraExpense",
      "showClear": true
    },
    model: {
      value: (_vm.extraExpenses),
      callback: function($$v) {
        _vm.extraExpenses = $$v
      },
      expression: "extraExpenses"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-3 p-lg-2 p-xl-2"
  }, [_c('extraExpensesDialog', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Add Extra Expenses'),
      expression: "'Add Extra Expenses'",
      modifiers: {
        "top": true
      }
    }],
    staticClass: "p-mt-5"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-4 p-xl-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpensesAmt"
    }
  }, [_vm._v("Amount")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "extraExpensesAmt"
    },
    model: {
      value: (_vm.extraExpenseAmt),
      callback: function($$v) {
        _vm.extraExpenseAmt = $$v
      },
      expression: "extraExpenseAmt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-xl-2"
  }, [_c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    attrs: {
      "for": "applyVat"
    }
  }, [_vm._v("Apply Vat")]), _vm._v(" "), _c('InputSwitch', {
    model: {
      value: (_vm.applyVat),
      callback: function($$v) {
        _vm.applyVat = $$v
      },
      expression: "applyVat"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('label', {
    attrs: {
      "for": "applyVat"
    }
  }, [_vm._v("Apply On Bill")]), _vm._v(" "), _c('InputSwitch', {
    model: {
      value: (_vm.applyExpensesOnBill),
      callback: function($$v) {
        _vm.applyExpensesOnBill = $$v
      },
      expression: "applyExpensesOnBill"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-offset-7 p-col-5 p-lg-offset-0 p-lg-3"
  }, [_c('div', {
    staticClass: "p-fluid p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-info btn-btm-0 width-auto p-button",
    attrs: {
      "label": !_vm.editExtraExpenses ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addExtraExpensesToList.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.editExtraExpenses) ? _c('div', {
    staticClass: "p-field p-col-6 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button p-button-danger width-auto",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancelExtraExpenses.apply(null, arguments)
      }
    }
  })], 1) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines finalCalc"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _vm._v(" "), _c('th', [_vm._v("Expenses Name")]), _vm._v(" "), _c('th', [_vm._v("Apply Vat")]), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.inventoryExtraExpensesList), function(expense, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpense.expensesName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.applyVat ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.extraExpenseAmt))]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editExtraExpensesDto(expense, index)
        }
      }
    }), _vm._v(" "), (_vm.editExtraExpenses) ? _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "disabled": "",
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    }) : _c('Button', {
      staticClass: "p-button-raised p-button-rounded p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    })], 1)])])
  })], 2)])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-9 p-xl-4"
  }, [_c('div', {
    staticClass: "p-datatable-responsive p-datatable-gridlines finalCalc"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Subtotal")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subTotal.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discount")]), _vm._v(" "), _c('th', [(_vm.chooseDiscountAmt) ? _c('Button', {
    attrs: {
      "label": "Rs"
    },
    on: {
      "click": _vm.chooseDisountAmt
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountPer) ? _c('Button', {
    attrs: {
      "label": "%"
    },
    on: {
      "click": _vm.chooseDisPercent
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('td', [(_vm.chooseDiscountPer) ? _c('InputText', {
    attrs: {
      "onfocus": "if (this.value === '0'){this.value = ''}",
      "placeholder": "discountPer"
    },
    model: {
      value: (_vm.discountPer),
      callback: function($$v) {
        _vm.discountPer = $$v
      },
      expression: "discountPer"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountAmt) ? _c('InputText', {
    attrs: {
      "onfocus": "if (this.value === '0'){this.value = ''}",
      "placeholder": "discountamt"
    },
    model: {
      value: (_vm.discountAmt),
      callback: function($$v) {
        _vm.discountAmt = $$v
      },
      expression: "discountAmt"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Discounted Amt:")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.discountAmt))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Excise Duty")]), _vm._v(" "), _c('th', [_c('InputNumber', {
    attrs: {
      "id": "excise",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.exciseDuty),
      callback: function($$v) {
        _vm.exciseDuty = $$v
      },
      expression: "exciseDuty"
    }
  }), _vm._v(" %\n              ")], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.exciseDuty))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Taxable")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.taxable.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Non-taxable")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.nonTaxable.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Tax")]), _vm._v(" "), _c('th', [_vm._v("13%")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.tax.toFixed(4)))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Total")]), _vm._v(" "), _c('th'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.totalBillAmount.toFixed(4)))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-md-4 p-xl-2 p-xl-offset-6"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-success",
    attrs: {
      "icon": "pi pi-save",
      "label": _vm.purchaseInvoice === undefined ? 'Save' : 'Update'
    },
    on: {
      "click": _vm.addPurchaseInvoice
    }
  })], 1), _vm._v(" "), (_vm.purchaseInvoice != undefined) ? _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.goBack()
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-info",
    attrs: {
      "label": "Print",
      "icon": "pi pi-print"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-md-4 p-xl-2"
  }, [(_vm.saved) ? _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  }) : _c('Button', {
    staticClass: "p-button-raised p-button-secondary",
    attrs: {
      "icon": "pi pi-download",
      "disabled": "",
      "label": "Generate PDF"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1)])], 1), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '50vw',
      height: '20vw'
    }),
    attrs: {
      "header": "Size Details",
      "visible": _vm.displayBasicForSizeAndColor,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasicForSizeAndColor = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised p-button-success",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasicSizeAndColor.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeBasicSizeAndColorCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("Size")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.sizeLists,
      "optionLabel": "label",
      "optionValue": "value",
      "filter": true,
      "placeholder": "Select Size",
      "id": "extraExpense",
      "showClear": true
    },
    model: {
      value: (_vm.sizeName),
      callback: function($$v) {
        _vm.sizeName = $$v
      },
      expression: "sizeName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("Color")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "options": _vm.colorLists,
      "optionLabel": "label",
      "optionValue": "value",
      "filter": true,
      "placeholder": "Select Size",
      "id": "extraExpense",
      "showClear": true
    },
    model: {
      value: (_vm.colorName),
      callback: function($$v) {
        _vm.colorName = $$v
      },
      expression: "colorName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("Closing Stock")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "disabled": "",
      "id": "inQuantity",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "extraExpense"
    }
  }, [_vm._v("In Qty")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "id": "quantity",
      "mode": "decimal",
      "onfocus": "if (this.value === '0.00'){this.value = ''}",
      "minFractionDigits": 2,
      "maxFracionDigits": 4
    },
    model: {
      value: (_vm.inQuantity),
      callback: function($$v) {
        _vm.inQuantity = $$v
      },
      expression: "inQuantity"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": !_vm.editDto ? 'Add' : 'Update'
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addInventoryStockSize.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [(_vm.editDto) ? _c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": _vm.itemDTOresetForSizeAndColor
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered",
    staticStyle: {
      "margin-top": "2em",
      "border": "1px solid #c8c8c8"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("S.N")]), _vm._v(" "), _c('th', [_vm._v("Size")]), _vm._v(" "), _c('th', [_vm._v("Color")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("In Quantity")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _vm._l((_vm.inventoryStockSizeList), function(expense, index) {
    return _c('tbody', {
      key: index
    }, [_c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.size))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.color))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(expense.inQuantity))]), _vm._v(" "), _c('td', [_c('Button', {
      staticClass: "p-button-raised p-button-success",
      attrs: {
        "icon": "pi pi-pencil"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editExtraExpensesDto(expense, index)
        }
      }
    }), _vm._v(" "), _c('Button', {
      staticClass: "p-button-raised p-button-danger",
      attrs: {
        "icon": "pi pi-trash"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeExtraExpense(expense, index)
        }
      }
    })], 1)])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    attrs: {
      "for": "itm"
    }
  }, [_vm._v("Item"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b0c94ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/purchase/purchaseinvoice.vue
// module id = 2030
// module chunks = 0